module.exports = __webpack_public_path__ + "img/img-main-bg.7401d954.png";